var render = function render(){var _vm=this,_c=_vm._self._c;return _c('UiAvatar',{staticClass:"selection-option-icon",class:{ 'is-text': Boolean(_vm.text) },attrs:{"shape":"square","size":25,"src":_vm.src || undefined,"fit":"contain","icon":!_vm.src && !_vm.text ? 'iconfont icon-tuxiang' : '',"aria-label":_vm.$t(_vm.alt)}},[(!_vm.src && _vm.text)?_c('span',[_vm._v(_vm._s(_vm.$t(_vm.text)))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }